import script from "./ReportBuilderDownloader.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportBuilderDownloader.vue?vue&type=script&setup=true&lang=js"

import "./ReportBuilderDownloader.vue?vue&type=style&index=0&id=5cddef12&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cddef12"]])

export default __exports__